<template lang="pug">
.tools
  template(v-if="module.type == 'PAN'")
    PanLayer
  template(v-if="module.type == 'RECT_SELECT'")
    TwoPointsPicker(v-model="module.rect", :normalize="true")
  template(v-if="module.type == 'LINE_SELECT'")
    TwoPointsPicker(v-model="module.line")
  RectOutline(:area="module.rect")
  GlobeObject(v-if="module.rect", :position="module.rect.c0.xyz")
    .menu
      button-menu
        template(v-if="Env.databaseService")
          menu-item(:label=`$t('query_objects')`, @click="Store.modules.cas.showSqlEditor = true")
          menu-item(:label=`$t('cutout')`, @click="Store.modules.imageCutout.showWindow = true")
          menu-separator
        menu-item(:label=`$t('clear')`, @click="module.rect = null")
  EditableLine(v-model="module.line")
  GlobeObject.nowrap(v-if="module.line", :position="module.line.c1.xyz")
    .menu
      button-menu
        ModuleOutlet(type="linearSelectionContextMenu")
        menu-separator
        menu-item(:label=`$t('clear')`, @click="module.line = null")
    .stat(v-html="lineLength", style="display: inline-block;")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { TwoPointsPicker } from "./TwoPointsPicker"
import { RectOutline } from "./RectOutline"
import { EditableLine } from "@/stellar-globe-components/Line";
import { ToolModule } from "@/modules/ToolModule";
import { GlobeObject } from "@/stellar-globe-components/GlobeObject";
import { EquatorialCoord } from "@hscmap/angle";
import { vec3 } from "gl-matrix";
import { angle60html } from "@/utils/angle";
import { PanLayer } from "@hscmap/stellar-globe";
import { Layer2Component } from '@/stellar-globe-components';

@Component({
  components: {
    TwoPointsPicker,
    RectOutline,
    EditableLine,
    GlobeObject,
    PanLayer: Layer2Component(PanLayer),
  },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: ToolModule

  get lineLength() {
    const { c0, c1 } = this.module.line!
    const d = vec3.dist(c0.xyz, c1.xyz)
    const t = 2 * Math.asin(d / 2)
    return angle60html(t)
  }
}
</script>


<style lang="scss" scoped>
.stat {
  color: magenta;
  background-color: rgba(31, 31, 31, 0.75);
  border-radius: 4pt;
}

.menu {
  display: inline-block;
  background-color: rgba(31, 31, 31, 0.75);
  color: white;
  border-radius: 2pt;
  margin-right: 0.25em;
}

.nowrap {
  white-space: nowrap;
}
</style>

<i18n>
en:
  query_objects: Query Objects
  cutout: Cutout
  clear: Clear
ja:
  query_objects: 天体を問い合わせる
  cutout: 切り出し
  clear: クリア

</i18n>